import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(id: string): Promise<Optional<ResponseData>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/Activity/${id}`;
	return axios.get(url).toOptionalMapped((x) => x.data);
}

export interface Response {
	data: ResponseData;
}

export type ResponseData = {
	id: string;
	sortOrder: number;
	nameTranslations: {
		[key: string]: string;
	};
};

export const defaultResponseData = (): ResponseData => {
	return {
		id: '',
		sortOrder: 0,
		nameTranslations: {},
	};
};
